import { motion } from "framer-motion";

const REVEAL_OFFSET_Y = 30;
const REVEAL_INITIAL = { opacity: 0, y: REVEAL_OFFSET_Y };
const REVEAL_VISIBLE = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, margin: "-80px" };
const REVEAL_EASE = [0.22, 1, 0.36, 1];
const REVEAL_DURATION = 0.8;

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={REVEAL_INITIAL}
        whileInView={REVEAL_VISIBLE}
        viewport={REVEAL_VIEWPORT}
        transition={{ duration: REVEAL_DURATION, delay, ease: REVEAL_EASE }}
    >
        {children}
    </motion.div>
);

export const Overline = ({ children, className = "" }) => (
    <p className={`text-xs uppercase tracking-[0.25em] font-medium text-amber-500/80 font-mono-accent ${className}`}>
        {children}
    </p>
);
